import React from 'react';
import { MapPin } from 'lucide-react';

/**
 * "View Map" button — opens Google Maps directions from the user's current
 * location to the given destination. Works on Android, iOS, and desktop.
 *
 * Builds a Google Maps URL like:
 *   https://www.google.com/maps/dir/?api=1&destination=<encoded address>
 *
 * Mobile devices open this in the Google Maps app (if installed) and use the
 * device's current GPS as the origin automatically.
 */
const buildAddressLine = (booking, type) => {
  const prefix = type === 'pickup' ? 'pickup' : 'delivery';
  const parts = [
    booking[`${prefix}_address`],
    booking[`${prefix}_area`],
    booking[`${prefix}_landmark`],
    booking[`${prefix}_location`],
    booking[`${prefix}_pincode`],
    'India',
  ].map(p => (p ? String(p).trim() : '')).filter(Boolean);
  return parts.join(', ');
};

export const ViewMapButton = ({ booking, type = 'pickup', size = 'sm', className = '', label = 'VIEW MAP' }) => {
  const address = buildAddressLine(booking, type);
  if (!address) return null;

  const href = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}&travelmode=driving`;

  const padding = size === 'xs' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-1 text-xs';
  const iconSize = size === 'xs' ? 10 : 12;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`view-map-${type}`}
      title={`Open directions to ${type} address`}
      className={`inline-flex items-center gap-1 ${padding} border-2 border-black bg-white hover:bg-[#FF4500] hover:text-white font-mono uppercase font-bold tracking-wide transition-colors whitespace-nowrap ${className}`}
    >
      <MapPin size={iconSize} />
      {label}
    </a>
  );
};

export default ViewMapButton;
